import { createContext } from "preact"
import { useContext } from "preact/hooks"

/**
 * Signals the *visible* result state to children that live alongside the
 * product grid (e.g. `TermsFacet`). The grid itself may be hidden because the
 * raw Nosto response had no renderable hits *or* because every rendered
 * `<nosto-dynamic-card>` resolved empty (`useAllCardsEmpty`). Either way the
 * user sees `<NoResults />`, so facet counts must collapse to 0 to match —
 * otherwise the user sees "Cotton (1)" sitting on an empty page.
 * follow-up).
 */
export type GridResultContextValue = {
  /** True iff `Category` / `Serp` will render product cards for the user. */
  hasVisibleResults: boolean
  /** True iff Nosto is currently fetching a new response. */
  loading: boolean
}

export const GridResultContext = createContext<GridResultContextValue | null>(null)

export function useGridResult(): GridResultContextValue | null {
  return useContext(GridResultContext)
}
